import { AbacoVuexModule, State } from "@abaco/web-common/src/app";

import { MessageCountStatus } from "./models/HelperInfo";

export default class UserVuexModule extends AbacoVuexModule {
    @State() userNavBarOpen!: boolean;
    @State() messageCount!: number;
    @State({ default: false }) darkMode!: boolean;

    @State({ default: { status: "NOT_INITIATED", messageCount: null } }) messageCountStatus!: MessageCountStatus;
}
